import React from 'react';
import { KatButton, KatModal } from '@amzn/katal-react';
import { FailedRequest, ErrorCode } from 'src/features/types/gslaApi';

const ERROR_DISPLAY_TEXT: Record<ErrorCode, string> = {
    INVALID_WAREHOUSE_HANDLING_TIER: 'Invalid Warehouse Handling Tier for this FC',
    INVALID_PRODUCTION_CAPABILITY: 'Invalid Production Capability for this FC',
    WAREHOUSE_NOT_FOUND: 'Warehouse not found',
};
const DEFAULT_ERROR_TEXT = 'Validation failed';

interface FailedRequestsModalProps {
    visible: boolean;
    onClose: () => void;
    errors: FailedRequest[];
}

/**
 * Modal that displays validation errors returned from Publish APIs.
 * Shows after a partial success publish — valid items were published,
 * but some items failed WHT or PC validation.
 */
export const FailedRequestModal: React.FC<FailedRequestsModalProps> = ({
    visible,
    onClose,
    errors
}) => {
    const formatError = (error: FailedRequest): string => {
        const parts = [`FC: ${error.warehouseId}`];
        if (error.productionCapability) {
            parts.push(`PC: ${error.productionCapability}`);
        }
        if (error.warehouseHandlingTier) {
            parts.push(`WHT: ${error.warehouseHandlingTier}`);
        }
        parts.push(ERROR_DISPLAY_TEXT[error.errorCode] ?? DEFAULT_ERROR_TEXT);
        return parts.join(' — ');
    };

    return (
        <KatModal
            visible={visible}
            title="Failed Requests"
        >
            <div>
                <p>Some items failed validation and were not published. Valid items were published successfully.</p>
                <p><strong>The following items failed:</strong></p>
                <ul style={{ maxHeight: '300px', overflowY: 'auto', paddingLeft: '20px' }}>
                    {errors.map((error, index) => (
                        <li key={index} style={{ marginBottom: '4px', color: '#D13212' }}>
                            {formatError(error)}
                        </li>
                    ))}
                </ul>
                <div style={{ marginTop: '16px' }}>
                    <KatButton onClick={onClose} variant="primary">
                        Acknowledge
                    </KatButton>
                </div>
            </div>
        </KatModal>
    );
};
